import {type RefObject, useEffect, useRef, useState} from "react";

import {useStickyIntersection} from "../../../hooks/use_sticky_intersection";
import {useAppDispatch} from "../../../store/hooks";
import {setOfferListingNavigationSticky, setStickyHeaderCurrentHeight, setStickyHeaderVisibility} from "../../state/offer_listing_slice";
import {stickyHeaderHeight} from "../constants/sticky_header_height";

type Params = {
    isMobile: boolean;
};

type Result = {
    wrapperRef: RefObject<HTMLDivElement | null>;
    isSticky: boolean;
    currentHeaderHeight: number;
};

/**
 * Handles sticky header behavior for offer listing:
 * - detects when header becomes sticky,
 * - toggles header visibility at threshold (using requestAnimationFrame),
 * - measures real header height (e.g. wrapped layout on tablet) via the wrapper’s first child when present,
 * - synchronizes sticky state, progress, and current height with Redux.
 */
export const useListingStickyHeaderBehavior = (params: Params): Result => {
    const {isMobile} = params;
    const wrapperRef = useRef<HTMLDivElement>(null);
    const scrollRafRef = useRef<number | null>(null);
    const stickyVisibilityRef = useRef<0 | 1>(0);
    const dispatch = useAppDispatch();
    const isSticky = useStickyIntersection(wrapperRef);
    const [currentHeaderHeight, setCurrentHeaderHeight] = useState(stickyHeaderHeight);

    useEffect(() => {
        dispatch(setOfferListingNavigationSticky(isSticky));
    }, [isSticky, dispatch]);

    useEffect(() => {
        if (isMobile || !wrapperRef.current) {
            stickyVisibilityRef.current = 0;
            dispatch(setStickyHeaderVisibility(0));
            dispatch(setStickyHeaderCurrentHeight(stickyHeaderHeight));
            return;
        }

        const updateFromScroll = () => {
            if (!wrapperRef.current) return;

            const elementTop = wrapperRef.current.getBoundingClientRect().top;
            const visibility: 0 | 1 = elementTop <= 0 ? 1 : 0;

            if (stickyVisibilityRef.current !== visibility) {
                stickyVisibilityRef.current = visibility;
                dispatch(setStickyHeaderVisibility(visibility));
            }
        };

        const handleScroll = () => {
            if (scrollRafRef.current !== null) return;

            scrollRafRef.current = requestAnimationFrame(() => {
                updateFromScroll();
                scrollRafRef.current = null;
            });
        };

        updateFromScroll();

        window.addEventListener("scroll", handleScroll, {passive: true});
        window.addEventListener("resize", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
            window.removeEventListener("resize", handleScroll);

            if (scrollRafRef.current !== null) {
                cancelAnimationFrame(scrollRafRef.current);
                scrollRafRef.current = null;
            }
        };
    }, [isMobile, dispatch]);

    useEffect(() => {
        if (isMobile || !isSticky || !wrapperRef.current) return;

        const elementTop = wrapperRef.current.getBoundingClientRect().top;
        const visibility: 0 | 1 = elementTop <= 0 ? 1 : 0;

        if (stickyVisibilityRef.current !== visibility) {
            stickyVisibilityRef.current = visibility;
            dispatch(setStickyHeaderVisibility(visibility));
        }
    }, [isSticky, isMobile, dispatch]);

    useEffect(() => {
        if (isMobile) return;
        if (!isSticky || !wrapperRef.current) return;

        const measured = wrapperRef.current.firstElementChild;
        if (!measured || !(measured instanceof HTMLElement)) return;

        const updateHeight = () => {
            const nextHeight = Math.max(stickyHeaderHeight, Math.round(measured.getBoundingClientRect().height));
            setCurrentHeaderHeight((prev) => (prev === nextHeight ? prev : nextHeight));
            dispatch(setStickyHeaderCurrentHeight(nextHeight));
        };

        updateHeight();

        const observer = new ResizeObserver(updateHeight);
        observer.observe(measured);

        return () => observer.disconnect();
    }, [isSticky, isMobile, dispatch]);

    return {wrapperRef, isSticky, currentHeaderHeight};
};
import {type RefObject, useEffect, useRef, useState} from "react";

import {useStickyIntersection} from "../../../hooks/use_sticky_intersection";
import {useAppDispatch} from "../../../store/hooks";
import {setOfferListingNavigationSticky, setStickyHeaderCurrentHeight, setStickyHeaderVisibility} from "../../state/offer_listing_slice";
import {stickyHeaderHeight} from "../constants/sticky_header_height";

type Params = {
    isMobile: boolean;
};

type Result = {
    wrapperRef: RefObject<HTMLDivElement | null>;
    isSticky: boolean;
    currentHeaderHeight: number;
};

/**
 * Handles sticky header behavior for offer listing:
 * - detects when header becomes sticky,
 * - toggles header visibility at threshold (using requestAnimationFrame),
 * - measures real header height (e.g. wrapped layout on tablet) via the wrapper’s first child when present,
 * - synchronizes sticky state, progress, and current height with Redux.
 */
export const useListingStickyHeaderBehavior = (params: Params): Result => {
    const {isMobile} = params;
    const wrapperRef = useRef<HTMLDivElement>(null);
    const scrollRafRef = useRef<number | null>(null);
    const stickyVisibilityRef = useRef<0 | 1>(0);
    const dispatch = useAppDispatch();
    const isSticky = useStickyIntersection(wrapperRef);
    const [currentHeaderHeight, setCurrentHeaderHeight] = useState(stickyHeaderHeight);

    useEffect(() => {
        dispatch(setOfferListingNavigationSticky(isSticky));
    }, [isSticky, dispatch]);

    useEffect(() => {
        if (isMobile || !wrapperRef.current) {
            stickyVisibilityRef.current = 0;
            dispatch(setStickyHeaderVisibility(0));
            dispatch(setStickyHeaderCurrentHeight(stickyHeaderHeight));
            return;
        }

        const updateFromScroll = () => {
            if (!wrapperRef.current) return;

            const elementTop = wrapperRef.current.getBoundingClientRect().top;
            const visibility: 0 | 1 = elementTop <= 0 ? 1 : 0;

            if (stickyVisibilityRef.current !== visibility) {
                stickyVisibilityRef.current = visibility;
                dispatch(setStickyHeaderVisibility(visibility));
            }
        };

        const handleScroll = () => {
            if (scrollRafRef.current !== null) return;

            scrollRafRef.current = requestAnimationFrame(() => {
                updateFromScroll();
                scrollRafRef.current = null;
            });
        };

        updateFromScroll();

        window.addEventListener("scroll", handleScroll, {passive: true});
        window.addEventListener("resize", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
            window.removeEventListener("resize", handleScroll);

            if (scrollRafRef.current !== null) {
                cancelAnimationFrame(scrollRafRef.current);
                scrollRafRef.current = null;
            }
        };
    }, [isMobile, dispatch]);

    useEffect(() => {
        if (isMobile || !isSticky || !wrapperRef.current) return;

        const elementTop = wrapperRef.current.getBoundingClientRect().top;
        const visibility: 0 | 1 = elementTop <= 0 ? 1 : 0;

        if (stickyVisibilityRef.current !== visibility) {
            stickyVisibilityRef.current = visibility;
            dispatch(setStickyHeaderVisibility(visibility));
        }
    }, [isSticky, isMobile, dispatch]);

    useEffect(() => {
        if (isMobile) return;
        if (!isSticky || !wrapperRef.current) return;

        const measured = wrapperRef.current.firstElementChild;
        if (!measured || !(measured instanceof HTMLElement)) return;

        const updateHeight = () => {
            const nextHeight = Math.max(stickyHeaderHeight, Math.round(measured.getBoundingClientRect().height));
            setCurrentHeaderHeight((prev) => (prev === nextHeight ? prev : nextHeight));
            dispatch(setStickyHeaderCurrentHeight(nextHeight));
        };

        updateHeight();

        const observer = new ResizeObserver(updateHeight);
        observer.observe(measured);

        return () => observer.disconnect();
    }, [isSticky, isMobile, dispatch]);

    return {wrapperRef, isSticky, currentHeaderHeight};
};
